export const HERO_ROTATION_INTERVAL = 7500;
